// remember the last clicked productPairEdit (we need to reopen it if the user opens the shoe size modal)
let lastOpenedModal;


// set up thumbs swiper
let thumbsSwiper = new Swiper('#productV7Thumbs', {
    slidesPerView: 'auto',
    spaceBetween: 9,
    breakpoints: {
        800: {
            spaceBetween: 16
        }
    }
});

// set up images swiper
let imageSwiper = new Swiper('#productV7Swiper', {
    slidesPerView: 1,
    spaceBetween: 50,
    thumbs: {
        swiper: thumbsSwiper,
    },
    navigation: {
        nextEl: document.querySelector('.productV7VisualBtn.next'),
        prevEl: document.querySelector('.productV7VisualBtn.prev'),
    },
});

// update active variant
let formData = {
    items: []
};

// top cover is based off of sport (GOLD INSOLES)
const sportToTopCover = {
    "Baseball/Softball": "B",
    "Basketball": "Y",
    "Ultimate Frisbee": "B",
    "Boxing/Wrestling": "B",
    "Cheerleading": "C",
    "Fitness": "Y",
    "Golf": "B",
    "Hiking": "Y",
    "Football": "B",
    "Lacrosse": "B",
    "Rugby": "B",
    "Running": "Y",
    "Soccer": "C",
    "Tennis/Pickleball": "Y",
    "Track & Field": "C",
    "Volleyball": "Y",
    "Walking": "Y",
    "Other": "Y",
}

// top cover is based of weight (SILVER INSOLES)
let weightToTopCover = {
    "70 - 100lbs": "L",
    "100 - 120lbs": "L",
    "121 - 150lbs": "L",
    "151 - 180lbs": "H",
    "181 - 210lbs": "H",
    "211 - 230lbs": "H",
    "231 - 260lbs": "H",
    "261lbs - Up": "H"
};

// function to take variables from product options to a formdata item
function getFormData(options, targetHandle) {
    // gender is a variant (make sure something is checked)
    let gender = options.gender ?? null;

    // sport is a property
    let sport = options.sport ?? null;

    // size is a variant
    let size = options.size ?? null;

    // weight is a property
    let weight = options.weight ?? null;

    // age is a property
    let age = options.age ?? null;

    // Determine product
    let targetProduct;
    if (targetHandle === "vktry-insoles-gold") {
        // the product is dependent on the weight
        targetProduct = goldWeightToProduct[weight];
    } else if (targetHandle === "vktry-insoles-silver") {
        targetProduct = silverProduct;
    } else if (targetHandle === "custom-orthotics-platinum") {
        targetProduct = platinumProduct;
    } else {
        new Error("Invalid targetHandle");
    }

    // platinum
    if (targetHandle === "custom-orthotics-platinum") {
        // gather item
        return {
            quantity: 1,
            id: targetProduct.variants[sport === 'Standard' ? 0 : 1].id,
            properties: {
                "Gender": gender,
                // "Sport": sport,
                "Size": size,
                "Weight": weight
            }
        };
    }

    // Determine Top Cover
    let topCover;
    if (targetHandle === "vktry-insoles-gold") {
        // top cover is variant that is dependent on the sport
        topCover = sportToTopCover[sport];
    } else if (targetHandle === "vktry-insoles-silver") {
        // top cover is variant that is dependent on the weight
        topCover = weightToTopCover[weight];
    } else {
        new Error("Invalid targetHandle");
    }

    // overrides
    if (targetHandle === "vktry-insoles-gold") {
        // AFTER determining the product (based on the weight) we check on special cases
        // Note we do not touch the weight variable since it's used as a line item property
        // if they are Female and size 151-180, it changes the weight to pro level 3 from level 4 (we have another case for ages 50 and up so we exclude that)
        if (gender === "Female" && weight === "151 - 180lbs" && age !== "50 and Up") {
            targetProduct = goldWeightToProduct["121 - 150lbs"];
        }

        // if they are age 50 & up, we decrease the pro level by 1
        if (age === "50 and Up") {
            if (weight === "261lbs - Up") {
                targetProduct = goldWeightToProduct["231 - 260lbs"];
            } else if (weight === "231 - 260lbs" || weight === "211 - 230lbs") {
                targetProduct = goldWeightToProduct["181 - 210lbs"];
            } else if (weight === "181 - 210lbs" || weight === "151 - 180lbs") {
                targetProduct = goldWeightToProduct["121 - 150lbs"];
            } else if (weight === "121 - 150lbs") {
                targetProduct = goldWeightToProduct["99 - 120lbs"];
            }
        }
    } else if (targetHandle === "vktry-insoles-silver") {
        // 37-H -> 37-L
        // 38-H -> 38-L
        if (
            gender === "Male" && size === "5-5.5" ||
            gender === "Female" && size === "7-7.5" ||
            gender === "Male" && size === "6-6.5" ||
            gender === "Female" && size === "8-8.5"
        ) {
            topCover = "L";
        }

        // 43-L -> 43-H
        // 44-L -> 44-H
        // 45-L -> 45-H
        if (
            gender === "Male" && size === "11-11.5" ||
            gender === "Female" && size === "13-13.5" ||
            gender === "Male" && size === "12-12.5" ||
            gender === "Male" && size === "13-13.5"
        ) {
            topCover = "H";
        }

        // athletes over 50 and 151-180 receive a topCover of L
        if (age === "50 and Up" && weight === "151 - 180lbs") {
            topCover = "L";
        }
    } else {
        new Error("Invalid targetHandle");
    }

    // option order is size, top cover, gender
    let selectedOptions = [size, topCover, gender];

    // find the correct variant based on the active options
    let activeVariant = null;
    for (let i = 0; i < targetProduct.variants.length; i++) {
        if (JSON.stringify(targetProduct.variants[i].options) === JSON.stringify(selectedOptions)) {
            activeVariant = targetProduct.variants[i];
            break;
        }
    }

    // check if active variant is not found in any setup
    if (activeVariant == null) {
        return false;
    }

    // gather item
    let formData = {
        quantity: 1,
        id: activeVariant.id,
        properties: {
            "Age": age,
            "Sport": sport,
            "Weight": weight
        }
    };

    // return
    return formData;
}

/**************
 Product Slider
 ***************/

// enable swiper
let productOptionSwiper = new Swiper("#productV7OptionSwiper", {
    allowTouchMove: false,
    autoHeight: true,
    spaceBetween: 30
});

// on change, check if Basketball or Volleyball is selected and show warning
if (document.querySelector("#productV7OptionSlideNoteSize")) {
    productOptionSwiper.on("slideChange", function () {
        let sport = document.querySelector(`.productV7OptionSlideLabel.active[data-group="sport"]`)?.dataset?.value
        if (sport === "Golf") {
            document.querySelector("#productV7OptionSlideNoteSize").textContent = "When ordering for golf, order a size up";
        } else if (sport === "Basketball" || sport === "Volleyball") {
            console.log(sport)
            document.querySelector("#productV7OptionSlideNoteSize").innerHTML = `Use measurements chart to confirm sizing`;
        } else {
            document.querySelector("#productV7OptionSlideNoteSize").textContent = "Use measurements chart to confirm sizing";
        }
    });
}


// Progress bar
productOptionSwiper.on("slideChange", function () {
    // enable all buttons
    document.querySelectorAll('.productV7InnerProgressCircleInner').forEach((element) => {
        element.disabled = false;
    });


    // update active progress bar circles
    document.querySelectorAll(".productV7InnerProgressCircleInner")?.forEach((element, index) => {
        if (index <= productOptionSwiper.activeIndex) {
            // we need to wait to add the active class
            // because the progress bar takes 300ms to animate
            setTimeout(() => {
                element.classList.add("active");
            }, 100);
        } else {
            element.classList.remove("active");
        }
    });

    // update active progress bar lines
    document.querySelectorAll(".productV7InnerProgressLineInner").forEach((element, index) => {
        element.classList.remove("active");
        if (index < productOptionSwiper.activeIndex) {
            element.classList.add("active");
        }
    });

    // Progress bar button click slide change
    document.querySelectorAll('.productV7InnerProgressCircleInner.active').forEach((element, index) => {
        element.addEventListener("click", function () {
            productOptionSwiper.slideTo(index);
        });
    });

});

// Progress bar final slide edge cases
// The final form is the last "slide" but isn't a swiper slide.
// We need to add the active class to the final progress bar/circle when
// the last swiper slide option is clicked, which is the weight group for platinum
// and is the age group for silver/gold.
let targetGroup
if (product.handle === "custom-orthotics-platinum") {
    targetGroup = "weight";
} else {
    targetGroup = "age";
}

document.querySelectorAll(`.productV7OptionSlideLabel[data-group='${targetGroup}']`)?.forEach(element => {
    element.addEventListener("click", function () {
        // add active class to all progress bar circles
        document.querySelectorAll(".productV7InnerProgressCircleInner")?.forEach((element, index) => {
            element.classList.add("active");
        });
        // add active class to all progress bar lines
        document.querySelectorAll(".productV7InnerProgressLineInner")?.forEach((element, index) => {
            element.classList.add("active");
        });

        // Since we're on the last slide, we need to disable the buttons
        document.querySelectorAll('.productV7InnerProgressCircleInner').forEach((element) => {
            element.disabled = true;
        });
    });
});

// update active variant on click
document.querySelectorAll(".productV7OptionSlideLabel").forEach(function (element) {
    element.addEventListener("click", function () {

        const group = this.dataset.group;
        const value = this.dataset.value;

        // remove active class from all items in this group
        document.querySelectorAll(`.productV7OptionSlideLabel[data-group="${group}"]`).forEach(element => element.classList.remove("active"));

        // add active class to this item
        this.classList.add("active");

        // go to next slide
        productOptionSwiper.slideNext();

        // slide back up to top of productV7OptionSwiper - 200px - only on the shoe slide
        if (group === "size") {
            let elementTop = document.querySelector('#productV7OptionSwiper').getBoundingClientRect().top + window.scrollY;
            let offset = 300;
            if (window.innerWidth < 800) {
                offset = 250;
            }
            window.scrollTo({
                top: elementTop - offset,
                behavior: 'smooth'
            });
        }

        // check if every group has an active item
        if (document.querySelectorAll(".productV7OptionSlide").length === document.querySelectorAll(".productV7OptionSlideLabel.active").length) {
            document.querySelector("#productV7OptionSwiper").classList.remove("active");
            document.querySelector("#productV7Form").classList.add("active");
        } else {
            document.querySelector("#productV7OptionSwiper").classList.add("active");
            document.querySelector("#productV7Form").classList.remove("active");
            return;
        }

        // create options object
        let options = {};
        document.querySelectorAll(`.productV7OptionSlideLabel.active`).forEach(element => {
            options[element.dataset.group] = element.dataset.value;
        });

        // save options
        document.querySelector(".productV7Pair").setAttribute("options", JSON.stringify(options));
        document.querySelector(".productV7Pair").classList.add("active");


        // update product
        updateProduct();
    });
})


// back button
document.querySelectorAll(".productV7OptionSlideNavBack").forEach(function (element) {
    element.addEventListener("click", function () {
        productOptionSwiper.slidePrev();
    });
});

// next button
document.querySelectorAll(".productV7OptionSlideNavNext").forEach(function (element) {
    element.addEventListener("click", function () {
        productOptionSwiper.slideNext();
    });
});

/*******************
 * Product Pairs
 */

// open edit
document.querySelectorAll(".productV7PairEdit").forEach(element => {
    element.addEventListener("click", function () {
        // save pair element
        let pairElement = this.closest(".productV7Pair");

        // save option element
        let options = pairElement.getAttribute("options");

        // open modal
        pairElement.querySelector(".productV7PairModal").showModal();

        // select options
        let optionsParsed = JSON.parse(options);
        pairElement.querySelectorAll(`.productV7PairModalLabelSelect`).forEach(element => {
            element.value = optionsParsed[element.getAttribute("name")]
        });

        lastOpenedModal = pairElement.querySelector(".productV7PairModal");
    })
});

// close event
document.querySelectorAll(".productV7PairModal").forEach(element => {
    element.addEventListener('close', function () {

        // save pair element
        let pairElement = this.closest(".productV7Pair");

        // check if this input has no options, then we hide it (it means they added a product with different options and canclled)
        if (!pairElement.getAttribute("options")) {
            pairElement.classList.remove("active");
        }

    });
})

// trigger close modal
document.querySelectorAll(".productV7PairModal,.productV7PairModalCancel,.productV7PairModalExit").forEach(element => {
    element.addEventListener("click", function (e) {
        if (e.target === this) {
            document.querySelector(".productV7PairModal[open]").close();
        }
    })
});

// form input events
document.querySelectorAll(".productV7PairModalLabelSelect").forEach(element => element.addEventListener("change", function () {
    // check if the entire form is ready
    let form = this.closest(".productV7PairModalContent");

    // check if all inputs are entered
    let ready = true;
    form.querySelectorAll(".productV7PairModalLabelSelect").forEach(input => {
        if (input.selectedIndex === 0) {
            ready = false;
        }
    });

    // update update button
    form.querySelector(".productV7PairModalUpdate").disabled = !ready;
}));

// update pair
document.querySelectorAll(".productV7PairModalContent").forEach(element => {
    element.addEventListener("submit", function (e) {
        e.preventDefault();

        // when we close the shoe size modal, it can trigger the productPairModalContent submit event
        // this boolean is here to prevent that
        if (preventSubmit) {
            return;
        }

        // save pair element
        let pairElement = this.closest(".productV7Pair");

        // set this option as active
        pairElement.classList.add("active");

        // update options attribute only if the option isn't the initial one
        let options = {};
        this.closest(".productV7PairModal").querySelectorAll(`.productV7PairModalLabelSelect`).forEach(element => {
            if (!element.value.includes("Choose")) {
                options[element.getAttribute("name")] = element.value;
            }
        });

        pairElement.setAttribute("options", JSON.stringify(options));

        // close modal
        document.querySelector(".productV7PairModal[open]").close();

        updateProduct();
    });
});

// remove
document.querySelectorAll(".productV7PairRemove").forEach(element => {
    element.addEventListener("click", function () {
        // save pair element
        let pairElement = this.closest(".productV7Pair");

        // remove active and options
        pairElement.classList.remove("active");
        pairElement.removeAttribute("options");

        // update product
        updateProduct();

        // check if there are no more left, reset the swiper to slide 1 and remove active classes on lebels
        if (document.querySelectorAll(".productV7Pair.active").length === 0) {
            document.querySelector("#productV7OptionSwiper").classList.add("active");
            document.querySelector("#productV7Form").classList.remove("active");
            document.querySelectorAll(".productV7OptionSlideLabel.active").forEach(element => element.classList.remove("active"));
            productOptionSwiper.slideTo(0);
            lastOpenedModal = null;
        }
    });
})

// same as first
document.querySelector("#productV7ActionSame").addEventListener("click", function () {
    // check for a free slot
    let nextFree = document.querySelector(".productV7Pair:not(.active)");
    if (nextFree) {
        nextFree.classList.add("active");
        nextFree.setAttribute("options", document.querySelector(".productV7Pair").getAttribute("options"));
    }
    updateProduct();
});

// new pair
document.querySelector("#productV7ActionNew").addEventListener("click", function () {
    //check for a free slot
    let nextFree = document.querySelector(".productV7Pair:not(.active)");
    if (nextFree) {
        nextFree.classList.add("active");
        nextFree.querySelector(".productV7PairModal").showModal();
    }

    lastOpenedModal = nextFree.querySelector(".productV7PairModal");
});


function updateProduct() {
    // reset atc button (atc active)
    document.querySelector("#productV7ATC").textContent = "Add To Cart";
    document.querySelector("#productV7ATC").classList.add("active");
    document.querySelector("#productV7ATC").classList.remove("disabled");
    document.querySelector("#productV7ATC").classList.remove("message");

    // show terms
    document.querySelector("#productV7Terms").classList.remove("active");

    // reset form data
    formData.items = [];
    document.querySelectorAll(".productV7PairTitle")?.forEach(element => element.classList.remove("active"));
    // hide error message
    document.querySelector("#productV7ATC").classList.remove("active");
    document.querySelectorAll(".productV7Pair.active").forEach((element, index) => {
        // reindex
        element.querySelector(".productV7PairTitle").textContent = `PAIR ${index + 1}`

        // add formdata
        let options = JSON.parse(element.getAttribute("options"));
        let item = getFormData(options, product.handle);

        // check if item is not found (variant can't be found)
        if (item === false) {
            // hide atc button
            document.querySelector("#productV7ATC").classList.add("active");

            // hide terms
            document.querySelector("#productV7Terms").classList.add("active");

            // show error message
            document.querySelector("#productV7Error").classList.add("active");

            // find that element
            let productPair = document.querySelector(`.productV7Pair[options='${JSON.stringify(options)}']`);

            // indicate that this pair is invalid by setting title to active
            productPair.querySelector(".productV7PairTitle").classList.add("active");

            return;
        }

        // show atc
        document.querySelector("#productV7ATC").classList.remove("active");

        // show terms
        document.querySelector("#productV7Terms").classList.remove("active");

        // hide error message
        document.querySelector("#productV7Error")?.classList.remove("active");

        // check for duplicates (id and property, if you check the entire object, the id won't match)
        for (let i = 0; i < formData.items.length; i++) {
            if (formData.items[i].id === item.id && JSON.stringify(formData.items[i].properties) === JSON.stringify(item.properties)) {
                formData.items[i].quantity++;
                return;
            }
        }

        // add item to form data
        formData.items.push(item);
    });
}

// pre-selects
function preselectURL() {
    const url = new URL(window.location.href);

    let gender = url.searchParams.get("gender");
    if (gender != null) {
        document.querySelector(`.productV7OptionSlideLabel[data-group="gender"][data-value="${gender}"]`)?.classList.add("active")
    }

    let sport = url.searchParams.get("sport");
    if (sport != null) {
        // undo sport url parameter adjustments
        sport = sport.replace("_", " & ").replace("-", "/");
        document.querySelector(`.productV7OptionSlideLabel[data-group="sport"][data-value="${sport}"]`)?.classList.add("active")
    }

    let size = url.searchParams.get("size");
    if (size != null) {
        document.querySelector(`.productV7OptionSlideLabel[data-group="size"][data-value="${size}"]`)?.classList.add("active")
    }
}

preselectURL();


/**************
 Product ATC
 ***************/

document.querySelector("#productV7ATC").addEventListener("click", async function () {
    // add loading animation
    this.classList.add("loading");

    // add product
    await addProduct(formData);

    // stop loading
    this.classList.remove("loading");

    // check for upsell
    if (["vktry-insoles-gold", "vktry-insoles-silver"].includes(product.handle)) {
        await openUpsell();
    }

    // open cart
    await openCart();
});


/********************************** Shoe Size **********************************/

// when the shoe size modal is opened, it closes all other modals
// if this happens while the product customizer dialog is opened, it causes the form to submit
// we need to prevent that submit

let preventSubmit = false;

// open shoe size modal
document.querySelectorAll(".openShoeSize").forEach(element => {
    element.addEventListener("click", function () {
        // Find the correct shoe size modal

        // The modal to open is based on the sport
        // Gold: Basketball, fitness, racquet sports, running, volleyball, walking/hiking, everyday
        // Black: Baseball, boxing, football, golf, lacrosse, rugby, ultimate frisbee
        // Red: Cheerleading, Track, Soccer
        let sport = document.querySelector(`.productV7OptionSlideLabel.active[data-group="sport"]`)?.dataset?.value;

        if (sport === "Basketball" || sport === "Fitness" || sport === "Tennis/Pickleball" || sport === "Running" || sport === "Volleyball" || sport === "Hiking" || sport === "Walking" || sport === "Other") {
            document.querySelector('#shoeSizeGold').showModal();
        } else if (sport === "Baseball/Softball" || sport === "Boxing/Wrestling" || sport === "Football" || sport === "Golf" || sport === "Lacrosse" || sport === "Rugby" || sport === "Ultimate Frisbee") {
            document.querySelector('#shoeSizeBlack').showModal();
        } else {
            document.querySelector('#shoeSizeRed').showModal();
        }

        document.querySelector("body").classList.add("noScroll");

        // prevent form submissions
        preventSubmit = true;
    })
});


//close shoe size event listener
document.querySelectorAll(".shoeSizeContentClose")?.forEach(function (element) {
    element.addEventListener("click", async function () {
        let target = this.dataset.target;
        await closeSize(target);
        // open back up modal once the shoe size modal is closed
        if (lastOpenedModal) {
            lastOpenedModal.showModal();
        }
        preventSubmit = false;

    });
});


//close shoe size event listener
document.querySelectorAll(".shoeSize")?.forEach(function (element) {
    element.addEventListener("click", async function (e) {
        if (e.target === this) {
            let target = element.id;
            await closeSize(target);

            // open back up modal once the shoe size modal is closed
            if (lastOpenedModal) {
                lastOpenedModal.showModal();
            }

            preventSubmit = false;
        }
    });
});


// close shoe size
function closeSize(target) {
    document.querySelector(`#${target}`).close();
    document.querySelector("body").classList.remove("noScroll");
}

// register dialogs
// wait for document to load first
document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("dialog.shoeSize")?.forEach(function (element) {
        dialogPolyfill.registerDialog(element);
    });
});


/**************
 Show form
 ***************/
// If they click the Customize orthotics button, show the in between form
// then they continue to the customizer
document.querySelector('.productV7UserItemBodyBtn.showStep').addEventListener('click', function () {
    document.querySelector('#productV7User').classList.remove('active');
    document.querySelector('#productV7Step').classList.add('active');
});

document.querySelector('.productV7StepBodyBtn.showForm').addEventListener('click', function () {
    document.querySelector('#productV7Step').classList.remove('active');
    document.querySelector('#productV7ContentWrap').classList.add('active');
});

/**************
 Scroll to FAQ
 ***************/

document.querySelector('#productV7').querySelectorAll('a[href^="#faq"]')?.forEach(function (element) {
    element.addEventListener('click', function (e) {
        e.preventDefault();
        // smooth scroll to the FAQ section
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
            target.scrollIntoView({
                behavior: 'smooth',
                block: 'start'
            });
        }

    })
})


/**************
 Product Gift
 ***************/

// listen for "Request as gift" click
document.querySelector(".productV7InnerGiftLabelInput").addEventListener("click", function () {

    // show/hide the gift message in the ATC FORM
    document.querySelector("#productV7Gift").classList.remove("active");
    if (this.checked) {
        document.querySelector("#productV7Gift").classList.add("active");
    }
});


// Submit gift form
document.querySelector('#productV7GiftFormSubmit').addEventListener('click', async function (e) {
    e.preventDefault();

    // create url params
    const giftParams = new URLSearchParams({
        fromName: document.querySelector("#productV7GiftFormName").value,
        handle: product.handle,
        formData: JSON.stringify(formData)
    }).toString();

    // send event to Klaviyo
    const response = await fetch(`https://api.maltertech.com/vktrygear/send-a-gift.php`, {
        method: "POST",
        body: new URLSearchParams({
            fromName: document.querySelector("#productV7GiftFormName").value,
            toEmail: document.querySelector("#productV7GiftFormEmail").value,
            purchaseURL: `https://${window.location.hostname}/pages/send-gift?${giftParams}`,
        })
    })
        .then(response => response.json())

    // check for error
    if (response.error) {
        await Swal.fire({
            title: 'Error',
            text: response.error,
        });
        return;
    }

    // update text
    document.querySelector("#productV7GiftTxt").textContent = "Your email was sent with the VKTRYs you would like as a gift.";
    document.querySelector('#productV7GiftForm').classList.remove('active');
});


// open moneyBack dialog
document.querySelectorAll('.openMoneyBack').forEach(function (element) {
    element.addEventListener('click', function () {
        document.querySelector("#moneyBack").showModal();
        document.querySelector("body").classList.add("noScroll");
    });
})

// close moneyBack
function closePopup() {
    document.querySelector("#moneyBack").close();
    document.querySelector("body").classList.remove("noScroll");
}

// close moneyBack event listener
document.querySelectorAll(".moneyBackClose").forEach(function (element) {
    element.addEventListener("click", closePopup);
});

document.querySelector("#moneyBack").addEventListener("click", function (e) {
    if (e.target === this) {
        closePopup();
    }
})

// close event
document.querySelector("#moneyBack").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#moneyBack"));


// open howWorks dialog
document.querySelectorAll('.productV7UserItemBodyPopup').forEach(function (element) {
    element.addEventListener('click', function () {

        // hide all videos
        document.querySelectorAll('.howWorksVideo').forEach(function (element) {
            element.classList.remove('active');
        })

        // show video based on class
        if (element.classList.contains('iPhone')) {
            document.querySelector('.howWorksVideo.iPhone').classList.add('active');
        } else {
            document.querySelector('.howWorksVideo.android').classList.add('active');
        }


        document.querySelector("#howWorks").showModal();
        document.querySelector("body").classList.add("noScroll");
    });
})

// close howWorks
function closeHowWorks() {
    document.querySelector("#howWorks").close();
    document.querySelector("body").classList.remove("noScroll");

    // stop video
    document.querySelectorAll(".howWorksVideo")?.forEach(function (video) {
        video.pause();
    })
}

// close howWorks event listener
document.querySelectorAll(".howWorksClose").forEach(function (element) {
    element.addEventListener("click", closeHowWorks);
});

document.querySelector("#howWorks").addEventListener("click", function (e) {
    if (e.target === this) {
        closeHowWorks();
    }
})

// close event
document.querySelector("#howWorks").addEventListener("close", function () {
    document.querySelector("body").classList.remove("noScroll");
});

// register dialog
dialogPolyfill.registerDialog(document.querySelector("#howWorks"));